'use client';

import { createZustandShallowStore } from '@/lib/zustand';
import { PSCCheckESurveyResponse } from '@/server/api/v1/psc-e-survey/type';

/**Trạng thái store ESurvey toàn cục */
interface ESurveyStoreState {
    /**Danh sách khảo sát chưa hoàn thành */
    surveyList: PSCCheckESurveyResponse[];
    /**
     * Tổng số khảo sát chưa thực hiện.
     * LeftSidebar đọc giá trị này để hiển thị badge số lượng bên cạnh menu "Khảo sát".
     */
    pendingCount: number;
    /**Cập nhật toàn bộ dữ liệu khảo sát — gọi sau mỗi lần fetch API thành công */
    setSurveyData: (surveys: PSCCheckESurveyResponse[]) => void;
    /**Xóa dữ liệu — gọi khi đăng xuất để tránh rò rỉ dữ liệu sang phiên khác */
    clearSurveyData: () => void;
}

/**
 * Store toàn cục cho dữ liệu ESurvey.
 *
 * Luồng dữ liệu:
 * 1. CheckSurveyOnline (layout) fetch ngay sau đăng nhập → gọi setSurveyData
 * 2. LeftSidebar đọc pendingCount → hiển thị badge
 * 3. SurveyManagement đọc surveyList → render ngay, không cần fetch lại
 * 4. Nút "Làm mới" trên trang Khảo sát → gọi lại API → gọi setSurveyData để cập nhật badge
 */
export const useESurveyStore = createZustandShallowStore<ESurveyStoreState>(
    (set) => ({
        surveyList: [],
        pendingCount: 0,

        setSurveyData: (surveys) =>
            set({
                surveyList: surveys,
                // pendingCount = số khảo sát còn trong danh sách (chưa làm)
                pendingCount: surveys.length,
            }),

        clearSurveyData: () =>
            set({ surveyList: [], pendingCount: 0 }),
    })
);
